import * as React from "react";

import classNames from "classnames";

import connectToList from "../../store/list";

import GenButton from "../Gen/Button";
import GenControlsBar from "../Gen/ControlsBar";
import GenListDisplay from "../Gen/ListDisplay";
import GenMore from "../Gen/More";
import GenSearchBox from "../Gen/SearchBox";
import GenSelectBar from "../Gen/SelectBar";
import GenSortButtons from "../Gen/SortButtons";

interface DocumentSetUserPermissionSelectListProps {
  documentSetId: number;
  documentSetUserPermissions: ConnectedList<DocumentSetUserPermissionSnakeModel>;
}

function DocumentSetUserPermissionSelectList(props: DocumentSetUserPermissionSelectListProps) {
  const {
    documentSetId,
    documentSetUserPermissions,
  } = props;

  React.useEffect(() => {
    documentSetUserPermissions.mountList(`/document_sets/${documentSetId}/document_set_user_permissions`);
  }, []);

  const [isSubmitLoading, setIsSubmitLoading] = React.useState(false);

  const handleSubmitButton = React.useCallback(() => {
    if (documentSetUserPermissions.selected.length === 0) {
      alert("Nothing Selected! You must select at least one user to remove");
      return;
    }

    const data = {
      documentSetUserPermissionIds: documentSetUserPermissions.selected.map((groupRoleDefinitionUser) => groupRoleDefinitionUser.id),
    };

    setIsSubmitLoading(true);

    fetch(`/document_sets/${documentSetId}/document_set_user_permissions/destroy_batch`, {
      method: "DELETE",
      body: JSON.stringify(data),
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
    })
      .then((response) => {
        if (!response.ok) { throw new Error(`${response.status} response` ); }

        return response.json();
      })
      .then(() => {
        documentSetUserPermissions.resetListSelected();
        documentSetUserPermissions.reloadList();
        setIsSubmitLoading(false);
        alert("Members Removed!");
      })
      .catch(() => {
        setIsSubmitLoading(false);
        alert("Error: Removing Members!");
      });
  }, [documentSetId, documentSetUserPermissions.selected]);

   return(
     <div>
       <GenSelectBar
         {...documentSetUserPermissions}
         itemType="member(s)"
         selectExtraButtons={(
           <GenButton
             name="Remove Selected Members"
             highlighted
             small
             loading={isSubmitLoading}
             disabled={documentSetUserPermissions.selected.length === 0}
             onClick={handleSubmitButton}
           />
        )}
       />
       <GenControlsBar>
         <GenSearchBox
           {...documentSetUserPermissions}
         />
         <GenSortButtons
           {...documentSetUserPermissions}
           sortOptions={[
            {
              "title": "First Name",
              "value": "first_name",
            },
            {
              "title": "Last Name",
              "value": "last_name",
            },
            {
              "title": "Email",
              "value": "email",
            },
          ]}
         />
       </GenControlsBar>
       <GenListDisplay
         {...documentSetUserPermissions}
         renderItem={(dsup, isSelected) => (
           <div className="flex">
             <div className={classNames("gen-select-list-select-area", {"bg-sky-600 ": isSelected})} />
             <div className="gen-select-list-select-item">
               <div className="type-group-role-summary">
                 <div className="topline">
                   <h1 className="full-name">
                     {`${dsup.user.first_name} ${dsup.user.last_name}`}
                   </h1>
                 </div>

                 <p className="email">{dsup.user.email}</p>
               </div>
             </div>
           </div>
        )}
       />
       <GenMore
         {...documentSetUserPermissions}
         shouldInfiniteScroll
       />
     </div>
   );
}

export default connectToList(DocumentSetUserPermissionSelectList, ["documentSetUserPermissions"]);
